export default "/kiban/_next/static/images/sheetCnt-cc5e8b808c6dadea402bea9888f9a2c7.png";